"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePointForLabel = exports.LINE_OFFSET = exports.LABEL_HEIGHT = exports.LABEL_WIDTH = void 0;
exports.LABEL_WIDTH = 280;
exports.LABEL_HEIGHT = 45;
exports.LINE_OFFSET = 15;
function calculatePointForLabel(_label, dot, labelElement, selectedPartID) {
    var _a;
    const rect = labelElement.getBoundingClientRect();
    const parentRect = (_a = labelElement.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    let x = rect.x;
    let y = rect.y;
    let width = rect.width || exports.LABEL_WIDTH;
    let height = rect.height || exports.LABEL_HEIGHT;
    let lineOffset = 0;
    let offsetY = height / 2;
    if (selectedPartID) {
        height = rect.height;
        offsetY = height / 2;
        if (_label.parts &&
            _label.parts.length > 4 &&
            parentRect &&
            rect.y >= parentRect.y + parentRect.height) {
            y = parentRect.y + parentRect.height - height;
        }
    }
    if (dot.x > x && dot.x < x + width) {
        x = x + width / 2;
        lineOffset = 0;
        if (y + height < dot.y) {
            y = y + height;
        }
    }
    else if (x > dot.x) {
        y = y + offsetY;
        lineOffset = -exports.LINE_OFFSET;
    }
    else {
        x = x + width;
        y = y + offsetY;
        lineOffset = exports.LINE_OFFSET;
    }
    return { x, y, lineOffset };
}
exports.calculatePointForLabel = calculatePointForLabel;
